<template>
  <div
    class="d-flex-column select_honor_picker justify-start align-start gap-0"
    style="margin-top: 18px"
  >
    <div
      class="d-flex-row space-between md-row-to-col select_honor_top top_small"
      style="margin-bottom: 20px"
    >
      <div class="d-flex-row justify-start flex-6 gap-18">
        <img
          :src="icon"
          alt="select_honor"
          class="orb_image b-radius-6"
          width="80"
          height="80"
        />
        <div class="d-flex-column justify-start align-start gap-0">
          <h6 class="bold-xxxl font-family-2 t-white">
            {{ title }}
          </h6>
          <p class="t-grey font-family-2 regular-m">
            {{ $t("select_orbs_1") }}{{ title }}{{ $t("select_orbs_2") }}
          </p>
        </div>
      </div>
      <div class="flex-4 flex-md-10 justify-end d-flex-row height-max-content">
        <ValueSetter
          v-model="orbs"
          :min="min_quantity"
          :max="in_stock"
          :step="1"
        />
      </div>
    </div>
    <RangePicker
      class="md-hide m-t-20p"
      :min="min_quantity"
      :max="in_stock"
      v-model="orbs"
      :step="1"
      :steps="[]"
      :startPoint="startPoint"
      :endPoint="endPoint"
      :stock="in_stock"
      :startMin="true"
    />
  </div>
</template>

<script setup>
import ValueSetter from "../../commonpickers/ValueSetter.vue";
import RangePicker from "./RangePicker.vue";
const orbs = ref(0);
const checkoutStore = useCheckoutStore();
const props = defineProps({
  title: {
    default: "",
  },
  icon: {
    default: "",
  },
  in_stock: {
    default: 0,
  },
  min_quantity: {
    default: 1,
  },
});

const startPoint = computed(() => {
  let suffixes = ["", "k", "M", "B", "T", "P", "E", "Z", "Y"];
  let magnitude = 0;
  let value = props.min_quantity; // Assign props.in_stock to a local variable

  while (Math.abs(value) >= 1000 && magnitude < suffixes.length - 1) {
    magnitude++;
    value /= 1000.0;
  }

  return value.toFixed(0) + suffixes[magnitude];
});
const endPoint = computed(() => {
  let suffixes = ["", "k", "M", "B", "T", "P", "E", "Z", "Y"];
  let magnitude = 0;
  let value = props.in_stock; // Assign props.in_stock to a local variable

  while (Math.abs(value) >= 1000 && magnitude < suffixes.length - 1) {
    magnitude++;
    value /= 1000.0;
  }

  return value.toFixed(0) + suffixes[magnitude];
});

watch(orbs, (newVal) => {
  //   console.log(newVal);
  checkoutStore.setDetails({
    ...checkoutStore.getDetails,
    numberOfOrbs: newVal,
  });
});
watch(
  () => props.min_quantity,
  (newVal) => {
    // orbs.value = props.min_quantity;
  }
);
</script>

<style lang="scss" scoped>
.orb_image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  object-position: center;
}
</style>
